import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, mergeProps as _mergeProps, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "company-assessment-form-select" }
const _hoisted_2 = {
  key: 0,
  class: "displaymode-text"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: null }, null, -1)
const _hoisted_4 = ["value"]

import { computed } from "vue";
import type { PropType } from "vue";
import { companyAssessmentInputProps } from "./companyAssessmentInputProps";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyAssessmentFormSelect',
  props: {
	modelValue: {
		type: Number as PropType<number | null>,
		required: true,
	},
	...companyAssessmentInputProps,
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const modelValue = computed({
	get: () => props.modelValue,
	set: (value: number | null) => emit("update:modelValue", value),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.displayMode)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.question.choices
						.find((c) => c.id === modelValue.value)
						?.translations.find((t) => t.languageCode === _ctx.language)?.text), 1))
      : _withDirectives((_openBlock(), _createElementBlock("select", _mergeProps({
          key: 1,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
          class: "form-select"
        }, _ctx.$attrs), [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.choices, (choice) => {
            return (_openBlock(), _createElementBlock("option", {
              key: choice.id,
              value: choice.id
            }, _toDisplayString(choice.translations.find((t) => t.languageCode === _ctx.language)?.text), 9, _hoisted_4))
          }), 128))
        ], 16)), [
          [_vModelSelect, modelValue.value]
        ])
  ]))
}
}

})